{
    "it-IT": "Italian - Italiano",
    "en-GB": "English",
    "fr-FR": "French - Français",
    "de-DE": "German - Deutch",
    "es-ES": "Spanish - Español",
    "ca-ES": "Catalan - Català",
    "en-US": "American",
    "es-US": "Spanish (US)",
    "hi-IN": "Hindi",
    "id-ID": "Indonesian",
    "ja-JP": "Japanese",
    "ko-KR": "Korean",
    "nl-NL": "Dutch",
    "pl-PL": "Polish",
    "pt-BR": "Portuguese (BR)",
    "ru-RU": "Russian",
    "uk-UA": "Ukrainian - Yкраїнська",
    "zh-CN": "Chinese",
    "zh-HK": "Chinese (HK)",
    "zh-TW": "Chinese (TW)",
    "ABOUT_BUILD": "Build",
    "ABOUT_EXPIRY": "Your subscription will expire on",
    "ABOUT_PLAN": "Subscription plan:",
    "ABOUT_TITLE": "About",
    "ABOUT_VERSION": "Version",
    "ACCESS-ADMIN-EMAIL": "Administrator email",
    "ACCESS-ADMIN-NAME": "Administrator name",
    "ACCESS-ADMIN-NOTES": "Administartor notes",
    "ACCESSCONFIG_ADMIN": "Administrator",
    "ACCESSCONFIG_BUY": "Purchase",
    "ACCESS_CONFIG": "Access management",
    "ACCESSCONFIG_BUY_SUBSCRIPTION": "Buy as private",
    "ACCESSCONFIG_CANCEL": "Cancel",
    "ACCESSCONFIG_CREATEDBY": "Created by",
    "ACCESSCONFIG_CREATIONDATE": "Creation date",
    "ACCESSCONFIG_DELETE_SUBSCRIPTION": "Delete subscription",
    "ACCESSCONFIG_DETAILS": "Configure access",
    "ACCESSCONFIG_DISCOVER": "Discover school offers",
    "ACCESSCONFIG_DOMAIN_DESC": "All the users with a Google account (not @gmail.com) and specified domani can access to Smxstudio.",
    "ACCESSCONFIG_DOMAIN": "Domain",
    "ACCESSCONFIG_DOMAINLICS_DESC": "It's the maximum users number for the specified domain. Use 0 to allow unlimited users.",
    "ACCESSCONFIG_DOMAINLICS": "Domain max users",
    "ACCESSCONFIG_DOMAIN_PLACEHOLDER": "Domain to enable",
    "ACCESSCONFIG_EXPIREDATE": "Expire date: ",
    "ACCESSCONFIG_EXPIRE_DATE_DESC": "It's the subscription expiry date",
    "ACCESSCONFIG_HISTORY": "Order history",
    "ACCESSCONFIG_INSERT_DOMAIN": "Add domain",
    "ACCESSCONFIG_INSERT_GROUP": "Add users group",
    "ACCESSCONFIG_INSERT_SINGLE": "Add single user",
    "ACCESSCONFIG_LASTMODIFICATIONBY": "Updated by",
    "ACCESSCONFIG_LASTMODIFICATIONDATE": "Last update",
    "ACCESSCONFIG_LICENSE_DOMAIN": "Domain",
    "ACCESSCONFIG_LICENSE_LICENSE": "licenses",
    "ACCESSCONFIG_LICENSE_MULTI": "Multiple",
    "ACCESSCONFIG_LICENSE_SINGLE": "Single",
    "ACCESSCONFIG_LICENSETYPE": "License type: ",
    "ACCESSCONFIG_LIMITED_LICENSES": "(up to %s users)",
    "ACCESSCONFIG_LOCKED": "Contract status",
    "ACCESSCONFIG_LOCKED_TRUE": "Waiting for acceptance",
    "ACCESSCONFIG_LOCKED_FALSE": "Accepted",
    "ACCESSCONFIG_LOCKED_ACCEPTED": "Acceptance date",
    "ACCESSCONFIG_MECHCODE": "Mechanographic code",
    "ACCESSCONFIG_MODIFY-ORDER": "Edit/Renew manually",
    "ACCESSCONFIG_MSG_DELETE_FAIL": "ERROR during subscription deletion",
    "ACCESSCONFIG_MSG_DELETE_OK": "Subscription has been deleted.",
    "ACCESSCONFIG_MSG": "Manage user email addresses of Smxstudio",
    "ACCESSCONFIG_MSG_SAVE_FAIL": "Access list saving failed.",
    "ACCESSCONFIG_MSG_SAVE_FAIL_ACCEPT": "Error saving contract acceptance.",
    "ACCESSCONFIG_MSG_SAVE_SUCCESS": "Access list saving success.",
    "ACCESSCONFIG_MSG_SINGLE": "Manage user email address of Smxstudio",
    "ACCESSCONFIG_NAME_DESC": "Write a name to identify this configuration. This name will be useful to identify the configuration in case of multiple subscriptions.",
    "ACCESSCONFIG_NAME": "Config name",
    "ACCESSCONFIG_NAME_PLACEHOLDER": "i.e. Section 2A or John's afterschool",
    "ACCESSCONFIG_OCR_QUOTA": "OCR Quota",
    "ACCESSCONFIG_OCR_POLICY": "OCR Counting",
    "ACCESSCONFIG_OPENSTATS": "Open statistics",
    "ACCESSCONFIG_OPERATORS": "Operators",
    "ACCESSCONFIG_ORDER_ACTIVE": "ACTIVE",
    "ACCESSCONFIG_ORDER_EXPIRED": "EXPIRED",
    "ACCESSCONFIG_ORDERID": "Key ID: ",
    "ACCESSCONFIG_ORDER_STATUS": "Order status: ",
    "ACCESSCONFIG_ORDER_SUSPENDED": "SUSPENDED",
    "ACCESSCONFIG_ORIGIN": "Origin: ",
    "ACCESSCONFIG_PLAN": "Plan",
    "ACCESSCONFIG_PRICE": "Price",
    "ACCESSCONFIG_PRICE_NA": "Not available",
    "ACCESSCONFIG_REFORDERID": "External reference ID: ",
    "ACCESSCONFIG_RENEW_INVALID_ORDER": "The order to be renewed is invalid. Please contact customer service.",
    "ACCESSCONFIG_RENEW_SUBSCRIPTION": "Renew subscription",
    "ACCESSCONFIG_RESET": "Cancel changes",
    "ACCESSCONFIG_SAVE": "Save",
    "ACCESSCONFIG_SENDADMINEMAIL": "Send email to administrator",
    "ACCESSCONFIG_SENDEMAIL": "Send email to buyer",
    "ACCESSCONFIG_SLOTS": "Additional emails",
    "ACCESSCONFIG_TITLE": " Access config",
    "ACCESSCONFIG_UNLIMITED_LICENSES": "(unlimited users)",
    "ACCESSCONFIG_UNLOCK": "I accept the contract",
    "ACCESSCONFIG_UPDATE_ORDER": "Update order",
    "ACCESSCONFIG_USERADMIN": "Administrator",
    "ACCESSCONFIG_USERADMIN_DESC": "Email account that can manage the supbscription's access permissions.",
    "ACCESSCONFIG_USERADMIN_DESC_SINGLE": "Email account that can manage the supbscription's access permissions.",
    "ACCESSCONFIG_USERADMIN_PLACEHOLDER": "Administrator email",
    "ACCESSCONFIG_USERADMIN_SINGLE": "Email",
    "ACCESSCONFIG_USER_NAME": "Buyer",
    "ACCESSCONFIG_USER_NAME_PLACEHOLDER": "Buyer's name",
    "ACCESSCONFIG_USERS": "Users",
    "ACCESSCONFIG_USERS_DESC": "Email adresses than can access SuperMapX.",
    "ACCESSCONFIG_USERS_DESC_NODOMAIN": "Email adresses than can access SuperMapsX not included in specified domain",
    "ACCESSCONFIG_USERS_NAME_PLACEHOLDER": "Name",
    "ACCESSCONFIG_USERS_NOTE_PLACEHOLDER": "Notes",
    "ACCESSCONFIG_USERS_PLACEHOLDER": "Email",
    "ACCESSCONFIG_USERS_WARNING": "WARNING: must be email Google accounts",
    "ACCESS-DOMAIN": "Domain name",
    "ACCESS-NAME": "Access name",
    "ACCESS-USERS-EMAIL": "Mail of user#",
    "ACCESS-USERS-NAME": "Name of user#",
    "ACCESS-USERS-NOTES": "Notes of user#",
    "ADD": "Add",
    "ADMIN_NAME": "Configuration name",
    "ADMIN_TITLE": "Access management",
    "ALIGNMENT_TOOLBAR-ALIGN": "Align",
    "ALIGNMENT_TOOLBAR-BOTTOM": "Bottom",
    "ALIGNMENT_TOOLBAR-CENTER": "Center",
    "ALIGNMENT_TOOLBAR-LEFT": "Left",
    "ALIGNMENT_TOOLBAR-RIGHT": "Right",
    "ALIGNMENT_TOOLBAR-TOP": "Top",
    "ALLSAVED": "All changes are saved",
    "APP_NAME": "Smxstudio",
    "ARRANGE_BASE": "The entire map will be reorganized as a top-bottom tree.",
    "ARRANGE_WARNING_START": "WARNING: This map contains some of these features:",
    "ARRANGE_WARNING_LOCKED": " • Locked nodes that won't be moved",
    "ARRANGE_WARNING_CURVES": " • Curved edges that will be straightened",
    "ARRANGE_WARNING_PAIRS": " • Pair-to-pair relations that could generate a bad map layout",
    "ARRANGE_WARNING_END": "Using this command could generate a map that will need manual adjustment.",
    "ARRANGE_CONFIRM": "Confirm?",
    "ASK_CLEAR_CHAT": "Delete the chat? Messages can no longer be recovered.",
    "ATTACHMENT": "Attachment",
    "BACK_TO_LOGIN": "Back to login",
    "BUTTON_CLOSE": "Close",
    "BUTTON_NO": "No",
    "BUTTON_OK": "Ok",
    "BUTTON_YES": "Yes",
    "CANCEL": "Cancel",
    "CAPTURE_CAMERA": "Capture",
    "CHAT_CLEAR": "Delete chat",
    "CHAT_MESSAGES_UNREAD": "UNREAD MESSAGES",
    "CHAT_SEND": "Send message",
    "CHAT_TODAY": "Today",
    "CHAT_YESTERDAY": "Yesterday",
    "CONFIG_SUBSCRIPTIONS": "Manage subscriptions",
    "COPY": "Copy",
    "COPY_LINK": "COPY",
    "COPY_MAP": "Create a copy",
    "COPY_MAP_FOR_EDIT": "Create a copy to edit",
    "COPYOF": "Copy of ",
    "COPY_PASTE_INFO1": "Copying and pasting in SMX studio",
    "COPY_PASTE_INFO2": "These actions are unavailable via the Edit menu, but you can still use:",
    "COPY_PASTE_INFO3_C": "for copy",
    "COPY_PASTE_INFO3_V": "for paste",
    "COPY_PASTE_INFO3_X": "for cut",
    "COPY_SHOW": "SHOW",
    "CREATE_GOOGLE_DOC": "Create Google Doc",
    "CREATE_MAP_ERROR": "Error creating new map",
    "CREATE_RECENT_COPY": "Create a copy",
    "CREATING_COPY": "Creating copy",
    "CURRENT_PAGE": "Page",
    "CUSTOM": "Custom",
    "DATE_NOTIFICATION": "Date: ",
    "DEEPTEXT": "In-depth text",
    "DEEP_OPEN_MODIFY": "Edit deep text",
    "DEEP_CLOSE_MODIFY": "Close editor",
    "DELETE_CONFIRM": "Do you really want to delete order '§orderid§'?",
    "DELETE_DEEPTEXT": "In-depth text",
    "DELETE_EDGE": "Edge",
    "DELETE": "Delete",
    "DELETE_IMAGE": "Image",
    "DELETE_LINK": "Link",
    "DELETE_NODE": "Node",
    "DELETE_TEXT": "Text",
    "DELETE_VIDEO": "Video",
    "DEMO_REQUEST_1": "You are requesting a demonstration period of 30 days, during which you will have access to all the features of Smxstudio.",
    "DEMO_REQUEST_2": "At the end of the demonstration period in the [Manage subscription] area you can purchase a subscription and continue using it, finding all your created maps.",
    "DEMO_REQUEST_3A": "To activate the demo period, press the",
    "DEMO_REQUEST_3B": "button and log in with the user you wish to activate.",
    "DEMO_REQUEST_4": "Please note: the account must be a valid Google email.",
    "DEMO_REQUEST_BUTTON": "Try it for 30 days",
    "DESC_APP": "Conceptual maps for learning",
    "DIRTY": "There are unsaved changes",
    "DOC_AUTHOR": "Author",
    "DOC_CREDITS": "Created with SMX Studio - Anastasis",
    "DOC_MAP_IMAGES": "Map images",
    "DOC_NOTES": "Notes",
    "DOC_MATH_IMAGES": "Math images",
    "DOC_MAP_QRCODE": "Map QRcode",
    "DOWNLOAD_CHROME2": "free Google Chrome browser is requested",
    "DOWNLOAD_CHROME": "To use Smxstudio you must download",
    "DOWNLOAD_RECENT": "Download",
    "DRIVE USAGE": "Google Drive usage",
    "EDIT_IMAGE": "Edit image",
    "EDIT_MODE": "Edit",
    "EDIT_NODE_TITLE": "Node title",
    "EDIT_NOTIFICATION": "Edit",
    "EDIT_TEXT": "Edit text",
    "EMAIL_ALREADY_EXISTS_MSG": " has been already added in the access list.",
    "EMPTY_NAME_NOT_ALLOWED": "Configuration name cannot be empty",
    "ERR_ACCESS_DENIED": "All scopes must be accepted in order to continue in Smxstudio",
    "ERR_EARLY_START": "Your account will be active from",
    "ERR_GDRIVE_3PTY_DISABLED": "Your domain administratore has disabled 3rd party apps.",
    "ERR_LOCKED": "This user is temporarily blocked.<br />You will be able to access after your administrator accepts the contract terms.",
    "ERR_LOGIN_BACK_TO_LOGIN": "Retry to login",
    "ERR_LOGIN_DOUBLE_ACCESS": "Double access. You'll be disconnected",
    "ERR_LOGIN_MIXED": "You must select the same use in both login pages",
    "ERR_LOGIN_INVALID_CREDENTIALS": "Your credentials are invalid",
    "ERR_LOGIN_SESSION_EXPIRED": "Your session has expired.",
    "ERR_TOKEN_EXPIRED": "Autorizza SMX studio ad usare Google",
    "ERR_LOGIN_NOT_VALID_SCOPES": "All scopes must be accepted in order to continue in Smxstudio",
    "ERR_LOGIN_GOOGLE": "Error in Google login",
    "ERROR_AUTHENTICATION": "Authentication error",
    "ERROR_CONVERTDATAURL": "Error convert data URL",
    "ERROR_DATABASE": "Generic database error",
    "ERROR_GENERATESME": "Generic generate sme error",
    "ERROR_GETPROTOCOL": "Error get http protocol",
    "ERROR_GOOGLEDRIVE": "Generic Google Drive error",
    "ERROR_MAPDOC_NOT_FOUND": "This document does not exist or is not shared anymore.\nDo you want to regenerate it?",
    "ERROR_GOOGLEID_NOT_FOUND": "Document does not exist or is not shared anymore",
    "ERROR_GRAPHML2JSON": "Generic error on converting graphml to json",
    "ERROR_INSERT_IMAGE": "Invalid image",
    "ERROR_INVALID_CREDENTIALS": "Google Drive access denied. Logout and login again to solve the problem.",
    "ERROR_LINK_PREVIEW": "Error link preview",
    "ERROR_MAP_FORMAT_NOT_SUPPORTED": "Unsupported file type",
    "ERROR_MAPJSONEMPTY": "Error Map JSON is empty",
    "ERROR_DOC_NOT_FOUND": "Map not found",
    "ERROR_MAP_NOT_SHARED": "This map is not shared",
    "ERROR_OPEN_MAP": "Error opening the map",
    "ERROR_OPENMAP": "Map not found",
    "ERROR_OWNER_NOT_FOUND": "This map does not exist",
    "ERROR_READFILE": "Generic error read file",
    "ERROR_RESIZEPNG": "Error resize to png",
    "ERROR-SAVING": "Warning! error on saving",
    "ERROR_SENDMAIL": "Error sending mail to user",
    "ERROR_STORAGE_DOWNLOAD": "Download from storage error",
    "ERROR_UNSUPPORTEDPROTOCOL": "Unsupported uri protocol",
    "ERROR_UNZIPMAP": "Error unzipping map",
    "ERROR_WRITEFILE": "Generic error write file",
    "ERROR_WRITEJSON": "Error writing JSON",
    "ERROR_WRONGFILETYPE": "Error wrong file type",
    "ERROR_WRONG_FILETYPE": "The file is not a valid .sme map",
    "ERROR_ZIPPER": "Error creating zip",
    "EXIT": "Exit",
    "EXIT_MESSAGE": "You have unsaved changes. Are you sure you want to leave this page?",
    "EXPIRE_DATE": "Expiry date",
    "EXP_WARNING_ACCOUNT_EXPIRED_DATE": "Your subscription expired on",
    "EXP_WARNING_ACCOUNT_EXPIRED": "Your subscription has expired",
    "EXP_WARNING_DEMO_EXPIRED_DATE": "Your demonstration expired on",
    "EXP_WARNING_DEMO_EXPIRED": "Your demonstration has expired",
    "EXP_WARNING_ACCOUNT_EXPIRING_DATE": "Your subscription will expire on",
    "EXP_WARNING_BUY": "Buy subscription",
    "EXP_WARNING_DEMO_EXPIRING_DATE": "Your demonstration will expire on",
    "EXP_WARNING_READONLY": "You can only see your maps in read-only mode.",
    "EXP_WARNING_RENEW_REFERRER": "To renew your subscription contact your referrer.",
    "EXP_WARNING_RENEW": "Renew subscription",
    "FIELD_REQUIRED": "Field required",
    "FIRST_PAGE_LABEL": "First page",
    "FLIP_HOR": "Flip horizontal",
    "FLIP_VERT": "Flip vertical",
    "FORBIDDEN": "You can't access to this resource",
    "FORMAT_COPY_FORMAT": "Copy format",
    "FORMAT_NODE_TOOLBAR-ARROW-LEFT": "Left arrow",
    "FORMAT_NODE_TOOLBAR-ARROW-RIGHT": "Right arrow",
    "FORMAT_NODE_TOOLBAR-BACKGROUND-COLOR": "Background color",
    "FORMAT_NODE_TOOLBAR-BOLD": "Bold",
    "FORMAT_NODE_TOOLBAR-BORDER-COLOR": "Border Color",
    "FORMAT_NODE_TOOLBAR-BORDER-SIZE": "Border size",
    "FORMAT_NODE_TOOLBAR-BREAK-LINK": "Break edge",
    "FORMAT_NODE_TOOLBAR-BRING-TO-FRONT": "Bring to front",
    "FORMAT_NODE_TOOLBAR-ELLIPSE": "Ellipse",
    "FORMAT_NODE_TOOLBAR-FONT": "Font",
    "FORMAT_NODE_TOOLBAR-FONT-SIZE": "Font size",
    "FORMAT_NODE_TOOLBAR-FRAME-IMAGE": "Frame",
    "FORMAT_NODE_TOOLBAR-HIGHLIGHT": "Highlight",
    "FORMAT_NODE_TOOLBAR-INSIDE": "Inside",
    "FORMAT_NODE_TOOLBAR-MYCOLOR": "My Colors",
    "FORMAT_NODE_TOOLBAR-NODE-SHAPE": "Node frame",
    "FORMAT_NODE_TOOLBAR-NONE": "None",
    "FORMAT_NODE_TOOLBAR-OVER": "Over",
    "FORMAT_NODE_TOOLBAR-RECTANGLE": "Rectangle",
    "FORMAT_NODE_TOOLBAR-REMOVE-IMAGE": "Remove immagine",
    "FORMAT_NODE_TOOLBAR-ROUNDRECT": "Rounded",
    "FORMAT_NODE_TOOLBAR-SEND-TO-BACK": "Send to back",
    "FORMAT_NODE_TOOLBAR-STRAIGHTEN-EDGE": "Straighten edge",
    "FORMAT_NODE_TOOLBAR-TEXT-COLOR": "Font color",
    "FORMAT_NODE_TOOLBAR-TEXT-POSITION": "Text Layout",
    "FORMAT_NODE_TOOLBAR-TEXT": "No frame",
    "FORMAT_NODE_TOOLBAR-UNDER": "Under",
    "FORMAT_NODE_TOOLBAR-CURVE-EDGE": "Edge type",
    "EDGE_STRAIGHT": "Stright",
    "EDGE_CURVE": "Curve",
    "FOUND_IN": "Found in: ",
    "FROM-CAMERA": "From camera",
    "FROM-GOOGLEDRIVE": "From Google Drive",
    "FROM-GOOGLEIMAGES": "From Google images",
    "FROM-LOCAL": "From local",
    "FROM-URL": "From URL",
    "FULLSCREEN-EXIT": "Go to window view",
    "FULLSCREEN": "Go to fullscreen view",
    "GATEWAY_TIMEOUT": "Gateway timeout",
    "GD3P_TEXT_01": "There were problems accessing yout map on Google Drive.",
    "GD3P_TEXT_02": "This is not a Smxstudio error.",
    "GD3P_TEXT_03": "Your domain administrator disabled 3rd party apps.",
    "GD3P_TEXT_04": "Please contact your domain administrator to activate 3rd party apps in Google Drive.",
    "GD3P_TEXT_05": "For further technical information click this <a href=\"https://support.google.com/a/answer/6105699?hl=en\">link</a>.",
    "GD3P_TITLE": "ERROR ACCESSING MAP",
    "GDNFU_TEXT_01": "You're not using first logged user on <b>Google</b>!",
    "GDNFU_TEXT_02": "Due to a <b>Google Drive</b> library limitation",
    "GDNFU_TEXT_03": "you have to logout from all your logged <b>Google</b> accounts",
    "GDNFU_TEXT_04": "and login with current user:",
    "GDNFU_TEXT_05": "Alternatively, you can use the integrated sharing dialog",
    "GDNFU_TEXT_06": "directly on <b>Google Drive</b> pages.",
    "GDRIVE_NEW_FILE_ERROR_GENERIC_MAP_NEW": "Can't create the map",
    "GDRIVE_NEW_TITLE": "Creating new map...",
    "GDRIVE_OPEN_FILE_ERROR_GENERIC_MAP_OPEN": "Can't open the map",
    "GDRIVE_OPEN_TITLE": "Opening map...",
    "GDRIVE_PICKER_BACK_TO_HOME": "Back to home",
    "GDRIVE_PICKER_ERROR_GENERIC_MAP_OPEN": "Can't open the map",
    "GDRIVE_PICKER_ERROR_LOADING_PICKER": "Can't access Google Drive",
    "GDRIVE_PICKER_TITLE": "Choose file",
    "GE_CODE": "Error code",
    "GENERAL_CANCEL": "Cancel",
    "GENERAL_OK": "Ok",
    "GENERIC_TOOLBAR-BACKGROUND-COLOR": "Color map background",
    "GENERIC_TOOLBAR_CHANGE-BACKGROUND-COLOR": "Change background color",
    "GENERIC_TOOLBAR_GRID": "Grid",
    "GENERIC_TOOLBAR_ARRANGE": "Arrange Map",
    "GENERIC_TOOLBAR_INSERT_NEW": "Insert",
    "GENERIC_TOOLBAR_INSERT_NEW_NODE": "Add new node",
    "GENERIC_TOOLBAR_INSERT_NEW_TABLE": "Add new table",
    "GENERIC_TOOLBAR_MATH_EDITOR": "Math Editor",
    "GENERIC_TOOLBAR_TABLE-SIZE": "Table Size",
    "GENERIC_TOOLBAR_TABLE": "Table",
    "GE_TEXT_01": "An error occurred while using Smxstudio",
    "GE_TEXT_02": "To restore it you can try to do one of these actions:",
    "GE_TEXT_03": "• Check that you have a working internet connection",
    "GE_TEXT_04": "• Reload the page (F5)",
    "GE_TEXT_05": "• Exit SMX studio (logout) and re-enter (login)",
    "GE_TEXT_06": "Press OK to close this message",
    "GOOGLE_DOC_CREATED": "Google document created!",
    "GOOGLE_DOC_UPDATED": "Google document updated!",
    "GOOGLE_DOC": "Google Document",
    "GOOGLE_DOC_MENU": "Google Document created",
    "GOOGLE": "Google",
    "GOOGLE_IMAGES": "Google images",
    "HEADER_ABOUT": "Information",
    "HEADER_ADMIN": "Manage subscriptions",
    "HEADER_FAQ": "FAQ",
    "HEADER_HOME": "Home",
    "HEADER_INFO_COPYRIGHT": "(C)opyright Anastasis Soc. Coop. Soc.",
    "HEADER_INFO": "About the app",
    "HEADER_LANGUAGE": "Language",
    "HEADER_LOGOUT": "Logout",
    "HEADER_LOGOUT_SUB": "Logging out from app will keep you logged in Google",
    "HEADER_MANUAL": "Manual",
    "HEADER_MAPINTRO": "Video manual",
    "HEADER_PRIVACY": "Privacy and security",
    "HEADER_USER": "User",
    "HEADER_LINKS": "Links Chrome Touch",
    "HEADER_LINKS_WINDOWS": "Windows",
    "HEADER_LINKS_LINUX": "Linux",
    "HEADER_LINKS_MAC": "Mac",
    "HOME_ERROR_GENERIC_MAP_LOAD": "Can't open the map",
    "HOME_ERROR_GENERIC_RECENT": "Can't load recent",
    "HOME_TITLE": "Home",
    "IC_TITLE": "Access to Smxstudio has been denied because you don't have any subscriptions.",
    "IC_SUBTITLE": "To use Smxstudio you need a subscription",
    "IC_BTN_WEBSITE_PRIVATE": "Buy as private",
    "IC_BTN_WEBSITE_SCHOOL": "Discover school offers",
    "IC_DEMO_REQUEST_BUTTON": "Request trial",
    "IC_LOGOUT": "Do you want to log in with another user?",
    "IC_LOGOUT_BUTTON": "Back to login",
    "IC_LOGIN_BUTTON": "Go to login",
    "IC_REQUEST_DEMO_1": "Try Smxstudio Suite Complete free for 30 days with all features",
    "IC_REQUEST_DEMO_2": "At the end of the demonstration period you can decide to purchase a subscription.",
    "IC_WEBSITE": "Go to the Smxstudio website where you can see prices and offers and buy your subscription.",
    "IC_USER_NAME": "The demonstration will be activated for user",
    "IC_USER_EMAIL": "that will be able to login using email",
    "IC_USER_NAME_EMAIL": "The demonstration will be activated for user that will be able to login using email",
    "IC_USER_TYPE_TITLE": "User type",
    "IC_USER_TYPE": "Please select your user type",
    "IC_USER_TYPE_": "Not set",
    "IC_USER_TYPE_PRIVATO": "Private",
    "IC_USER_TYPE_INSEGNANTE": "Teacher",
    "IC_USER_TYPE_EDUCATORE": "Educator",
    "IC_USER_TYPE_FIGURA_CLINICA": "Clinical figure",
    "IC_USER_TYPE_LOGOPEDISTA": "Speech terapist",
    "IC_USER_TYPE_ASL": "ASL",
    "IC_USER_TYPE_SCUOLA": "School",
    "IC_USER_TYPE_UNIVERSITA": "University",
    "IMAGE_COPIED": "Map image copied in clipboard",
    "IMAGE": "Image",
    "IMAGE_NODE": "Node image",
    "IMAGE_NOT_COPIED": "ERROR DURING MAP COPY!",
    "IMAGE_TOOLBAR": "Insert images",
    "INFORMATION": "Information",
    "INPUT-IMAGE-URL": "Paste Image url",
    "INPUT_LINK_URL": "Insert link URL",
    "INPUT_LINK_URL_PREVIEW": "Insert link only (no image and title on node)",
    "INPUT_MAPNAME": "Name",
    "INSERT-ATTACHMENT": "Insert attachment",
    "INSERT_BLOCKNOTES": "Insert in block notes",
    "INSERT_IMAGE": "Insert image",
    "INSERT-IMAGE": "Insert image",
    "INSERT_IN_MAP": "Insert in map",
    "INSERT_MATH": "Mathematics",
    "INSERT": "Insert",
    "INSERT_LINK": "Insert link",
    "ITEMS_PER_PAGE_LABEL": "Per page:",
    "LANGUAGE_TOOLBAR": "Language",
    "LAST_PAGE_LABEL": "Last page",
    "LIABILITY_CONTENT": "<br/><h2><b>Declaration of responsibility for contents</b></h2><div><p>I declare that I take legal responsibility for the contents that I will insert and share in Smxstudio.</p></div>",
    "LIABILITY_ERROR": "Required",
    "LINK_COPIED": "Link copied in clipboard",
    "LINKS-GOOGLE-DRIVE": "From Google Drive",
    "LINKS": "Links",
    "LINKS-MAP": "Map",
    "LINKS-EDITOR": "Document",
    "LINKS-PDF": "PDF",
    "LINKS-VIDEO": "Video",
    "LINK_UNAVAILABLE": "Link is not available",
    "LOGIN": "Login",
    "LOGIN_COMMAND_LOGIN": "Login with Google",
    "LOGIN_COOKIES_INFO": "How to enable third-part cookies",
    "LOGIN_COOKIES_URL": "https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en&oco=0",
    "LOGIN_FIRST_1": "Is this your first login?",
    "LOGIN_FIRST_2": "Consult in preview the documents related to our",
    "LOGIN_MOBILE_1": "Smxstudio operation is not guaranteed",
    "LOGIN_MOBILE_2": "using the browser of a mobile device",
    "LOGIN_NEEDS_GOOGLE_ACCOUNT": "An active Smxstudio subscription is required.",
    "LOGIN_DISCOVER_MORE": "Discover more",
    "LOGIN_DOWNLOAD_APP": "Download the App:",
    "LOGIN_ERROR_GENERIC": "Error authenticating user",
    "LOGIN_TITLE": "Login",
    "LOGIN_TITLE_DEMO": "Activate demonstration",
    "LOGIN_LINK_PRIVACY": "Privacy policy",
    "LOGIN_MOBILE_WARNING": "WARNING",
    "LOGIN_MOBILE_MESSAGE": "Smxstudio operation is not assured if you use a mobile device browser.",
    "LOGIN_SUBSCRIPTION": "You don't have an active Smxstudio subscription yet?",
    "LOGIN_MAPS_AND_MORE": "MAPS and more",
    "LOGIN_UNDER_MAPS": "Maps",
    "LOGIN_UNDER_NOTEPAD": "Notepad",
    "LOGIN_UNDER_DRAW": "Draw",
    "LOGIN_UNDER_OUTLINE": "Outline",
    "LOGIN_UNDER_PDF": "PDF",
    "LOGIN_UNDER_MATH": "Math",
    "MADE_WITH": "made with Smxstudio (C) Anastasis Soc.Coop.Soc.",
    "MAIL_SENT": "Email sent",
    "MAIN_MENU_ARRANGE-ALIGN": "Align",
    "MAIN_MENU_ARRANGE-ALIGN-BOTTOM": "Bottom",
    "MAIN_MENU_ARRANGE-ALIGN-HORZCENTER": "Center (horizontal)",
    "MAIN_MENU_ARRANGE-ALIGN-LEFT": "Left",
    "MAIN_MENU_ARRANGE-ALIGN-RIGHT": "Right",
    "MAIN_MENU_ARRANGE-ALIGN-TOP": "Top",
    "MAIN_MENU_ARRANGE-ALIGN-VERTCENTER": "Center (vertical)",
    "MAIN_MENU_ARRANGE": "Arrange",
    "MAIN_MENU_ARRANGE-ORDER-BRINGTOFRONT": "Bring to front",
    "MAIN_MENU_ARRANGE-ORDER": "Order",
    "MAIN_MENU_ARRANGE-ORDER-SENDTOBACK": "Send to back",
    "MAIN_MENU_ARRANGE-SIZE": "Size",
    "MAIN_MENU_ARRANGE-SIZE-SAMEHEIGHT": "Same height",
    "MAIN_MENU_ARRANGE-SIZE-SAMESIZE": "Same size",
    "MAIN_MENU_ARRANGE-SIZE-SAMEWIDTH": "Same width",
    "MAIN_MENU_EDIT-BACKGROUND": "Background color",
    "MAIN_MENU_EDIT-COPY-ALL": "Node",
    "MAIN_MENU_EDIT-COPY": "Copy",
    "MAIN_MENU_EDIT-COPY-DEEP": "Copy deep text",
    "MAIN_MENU_EDIT-COPY-IMAGE": "Copy image",
    "MAIN_MENU_EDIT-COPY-LINK": "Copy attachment",
    "MAIN_MENU_EDIT-COPY-MAP-IMAGE": "Copy map image",
    "MAIN_MENU_EDIT-COPY-TEXT": "Copy text",
    "MAIN_MENU_EDIT-CUT": "Cut",
    "MAIN_MENU_EDIT-DELETE": "Delete",
    "MAIN_MENU_EDIT": "Edit",
    "MAIN_MENU_EDIT-PASTE": "Paste",
    "MAIN_MENU_EDIT-REDO": "Redo",
    "MAIN_MENU_EDIT-TEXT": "Node title",
    "MAIN_MENU_EDIT-UNDO": "Undo",
    "MAIN_MENU_FILE-COPY-MAP": "Create a copy",
    "MAIN_MENU_FILE-CREATE-A-COPY": "Create a copy...",
    "MAIN_MENU_FILE-CREATE-A-DOC": "Create a Google document",
    "MAIN_MENU_FILE-DOC": "Google document created",
    "MAIN_MENU_FILE-EXPORT": "Download as...",
    "MAIN_MENU_FILE-EXPORT-TO-IMAGE": "Image (jpg)",
    "MAIN_MENU_FILE-EXPORT-TO-IMAGE-QRCODES": "Image + QRcodes (jpg)",
    "MAIN_MENU_FILE-EXPORT-TO-MAP": "Map (sme)",
    "MAIN_MENU_FILE-EXPORT-TO-IMAGE-PDF": "Image (PDF)",
    "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-PDF": "Document (PDF)",
    "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-DOCX": "Document (Docx)",
    "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-DOCX-MS": "for Microsoft Office",
    "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-DOCX-LO": "for LibreOffice",
    "MAIN_MENU_FILE": "File",
    "MAIN_MENU_FILE-IMPORT-MAP": "Import map",
    "MAIN_MENU_FILE-LIM-KEYBOARD": "Keyboard",
    "MAIN_MENU_FILE-LIM-ONLY-TOUCH": "Touch",
    "MAIN_MENU_FILE-LIM-PREFERENCES": "Interactive Whiteboard",
    "MAIN_MENU_FILE_MAP-LANGUAGE": "Map Language",
    "MAIN_MENU_FILE-NEW-MAP": "New map",
    "MAIN_MENU_FILE-OPEN-DOC": "Open document",
    "MAIN_MENU_FILE-OPEN-MAP": "Open map",
    "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-ALL": "All the images",
    "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER": "Image filter",
    "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE-COM": "Free to use, also commercial",
    "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE": "Free to use",
    "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE-MOD-COM": "Free to use and modify, also commercial",
    "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE-MOD": "Free to use and modify",
    "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-SAFESEARCH": "Safe search: ACTIVE",
    "MAIN_MENU_FILE-PREFERENCES": "Settings",
    "MAIN_MENU_FILE-PREFERENCES-PRINT-DRAFT": "Draft",
    "MAIN_MENU_FILE-PREFERENCES-PRINT-HIGH": "High",
    "MAIN_MENU_FILE-PREFERENCES-PRINT-MAXIMUM": "Maximum",
    "MAIN_MENU_FILE-PREFERENCES-PRINT-NORMAL": "Normal",
    "MAIN_MENU_FILE-PREFERENCES-PRINT": "Print quality",
    "MAIN_MENU_FILE-PREFERENCES-PRINT-VERYHIGH": "Very high",
    "MAIN_MENU_FILE-PRINT-MAP": "Map",
    "MAIN_MENU_FILE-PRINT-MAP-QRCODES": "Map + QRcodes",
    "MAIN_MENU_FILE-PRINT": "Print",
    "MAIN_MENU_FILE-RENAME": "Rename",
    "MAIN_MENU_FILE-REVISION-HISTORY": "History",
    "MAIN_MENU_FILE-SHARE": "Share",
    "MAIN_MENU_FILE-SHOW-MAP": "Show mappa",
    "MAIN_MENU_FILE-TEXT-BACKCOLOR": "Highlighter",
    "MAIN_MENU_FILE-TEXT-COLOR": "Font color",
    "MAIN_MENU_FILE-TEXT-PREFERENCES": "Text",
    "MAIN_MENU_FILE-TOUCH-PREFERENCES": "Enable touch",
    "MAIN_MENU_FILE-UPDATE-DOC": "Update document",
    "MAIN_MENU_FILE-VIEW-MAP": "View mappa",
    "MAIN_MENU_FORMAT-ARROW-BREAKARROW": "Break arrow",
    "MAIN_MENU_FORMAT-ARROW-COLOR": "Line color",
    "MAIN_MENU_FORMAT-ARROW": "Arrow",
    "MAIN_MENU_FORMAT-ARROW-LEFTARROW": "Left tip",
    "MAIN_MENU_FORMAT-ARROW-RIGHTARROW": "Right tip",
    "MAIN_MENU_FORMAT-ARROW-STRAIGHTEN": "Straighten arrow",
    "MAIN_MENU_FORMAT-ARROW-THICKNESS": "Line thickness",
    "MAIN_MENU_FORMAT": "Format",
    "MAIN_MENU_FORMAT-NODE-BACKCOLOR": "Background color",
    "MAIN_MENU_FORMAT-NODE-COLOR": "Line color",
    "MAIN_MENU_FORMAT-NODE-DELETEIMAGE": "Delete image",
    "MAIN_MENU_FORMAT-NODE-IMAGEFRAME": "Add/Remove frame",
    "MAIN_MENU_FORMAT-NODE": "Node",
    "MAIN_MENU_FORMAT-NODE-SHAPE": "Node shape",
    "MAIN_MENU_FORMAT-NODE-TEXTLAYOUT": "Text layout",
    "MAIN_MENU_FORMAT-NODE-THICKNESS": "Shape thickness",
    "MAIN_MENU_FORMAT-TABLE-DELETECOL": "Delete column",
    "MAIN_MENU_FORMAT-TABLE-DELETEROW": "Delete row",
    "MAIN_MENU_FORMAT-TABLE-DELETETABLE": "Delete table",
    "MAIN_MENU_FORMAT-TABLE-INSERTCOLAFTER": "Insert column after",
    "MAIN_MENU_FORMAT-TABLE-INSERTCOLBEFORE": "Insert column before",
    "MAIN_MENU_FORMAT-TABLE-INSERTROWOVER": "Insert row over",
    "MAIN_MENU_FORMAT-TABLE-INSERTROWUNDER": "Insert row under",
    "MAIN_MENU_FORMAT-TABLE": "Table",
    "MAIN_MENU_FORMAT-TEXT-BACKCOLOR": "Highlighter color",
    "MAIN_MENU_FORMAT-TEXT-COLOR": "Font color",
    "MAIN_MENU_FORMAT-TEXT-EFFECTS-BOLD": "Bold",
    "MAIN_MENU_FORMAT-TEXT-EFFECTS": "Effects",
    "MAIN_MENU_FORMAT-TEXT-EFFECTS-ITALIC": "Italic",
    "MAIN_MENU_FORMAT-TEXT-EFFECTS-SUBSCRIPT": "Subscript",
    "MAIN_MENU_FORMAT-TEXT-EFFECTS-SUPERSCRIPT": "Superscript",
    "MAIN_MENU_FORMAT-TEXT-EFFECTS-UNDERLINE": "Underline",
    "MAIN_MENU_FORMAT-TEXT-FONTSIZE": "Size",
    "MAIN_MENU_FORMAT-TEXT-FONT": "Font type",
    "MAIN_MENU_FORMAT-TEXT-LANGUAGE": "Selecion language",
    "MAIN_MENU_FORMAT-TEXT": "Text",
    "MAIN_MENU_INSERT-DEEPTEXT": "Deep text",
    "MAIN_MENU_INSERT": "Insert",
    "MAIN_MENU_INSERT-LINK-GOOGLE-DRIVE": "From Google Drive",
    "MAIN_MENU_INSERT-LINK": "Link",
    "MAIN_MENU_INSERT-LINK-MAP": "Map",
    "MAIN_MENU_INSERT-NODE": "Node",
    "MAIN_MENU_INSERT-QUICKEDIT": "Quick insert",
    "MAIN_MENU_INSERT-QUICKSPEECH": "Speech insert",
    "MAIN_MENU_INSERT-TABLE": "Table",
    "MAIN_MENU_SELECT": "Select",
    "MAIN_MENU_SELECT-ALL": "Select all",
    "MAIN_MENU_SELECT-NODES": "Select all nodes",
    "MAIN_MENU_SELECT-EDGES": "Select all edges",
    "MAIN_MENU_VIEW-CLOSE-NODES": "Close all nodes",
    "MAIN_MENU_VIEW-FIT": "Fit view",
    "MAIN_MENU_VIEW-GRID": "Grid",
    "MAIN_MENU_VIEW-OPEN-NODES": "Open all nodes",
    "MAIN_MENU_VIEW-QRCODE-GDOC": "Google Document",
    "MAIN_MENU_VIEW-QRCODE-MAP": "Map",
    "MAIN_MENU_VIEW-QRCODE": "QR code",
    "MAIN_MENU_VIEW": "View",
    "MAIN_MENU_VIEW-ZOOM-100": "Zoom 100%",
    "MAIN_MENU_VIEW-ZOOM-IN": "Zoom in",
    "MAIN_MENU_VIEW-ZOOM-OUT": "Zoom out",
    "MAIN_MENU_TOOLS": "Tools",
    "MAINTENANCE": "Maintenance",
    "MAIN_TOOLBAR_BLOCKNOTES": "Block notes",
    "MAIN_TOOLBAR_ADD_TOOLS": "Additional tools",
    "MAIN_TOOLBAR_CHAT": "Chat",
    "MAIN_TOOLBAR_CLEARREADORDER": "Clear",
    "MAIN_TOOLBAR_CLOSE_NODES": "Restart map show",
    "MAIN_TOOLBAR_DEFAULTREADORDER": "Default read order",
    "MAIN_TOOLBAR_EDITSHOW": "Edit",
    "MAIN_TOOLBAR_EXPORT-TO-IMAGE": "Download as image",
    "MAIN_TOOLBAR_EXPORT-TO-SME": "Download as sme",
    "MAIN_TOOLBAR_EXTRA": "Widget",
    "MAIN_TOOLBAR_FIND": "Find in map",
    "MAIN_TOOLBAR_GOTOEDITMODE": "Go back to map",
    "MAIN_TOOLBAR_HISTORY": "Revisions",
    "MAIN_TOOLBAR_INTERACTION_MODE": "Hand mode",
    "MAIN_TOOLBAR_MODIFYTEXT": "Modify text",
    "MAIN_TOOLBAR_OPEN_NODES": "Show whole map",
    "MAIN_TOOLBAR_OUTLINE": "Outline",
    "MAIN_TOOLBAR_PDF": "PDF",
    "MAIN_TOOLBAR_QRCODE": "Share with QRcode",
    "MAIN_TOOLBAR_QUICKEDIT": "Quick edit",
    "MAIN_TOOLBAR_REDO": "Redo",
    "MAIN_TOOLBAR_SEARCHWEB": "Search on web",
    "DRAW_TOOLS": "Drawing tools",
    "DESMOS_MATH_TOOLS": "Math tools",
    "AUTODRAW_DESC_1": "Autodraw is provided by ",
    "DESMOS_DESC_1": "Desmos tools are provided by",
    "DESMOS_DESC_2": "Anastasis does not provide assistance or guarantees on these services.",
    "DESMOS_DESC_3": "In order to use these tools from the widget Menu",
    "DESMOS_DESC_4": " you have to enable them from the menu below and save.",
    "DESMOS_CALCULATOR": "Graphing Calculator",
    "DESMOS_SCIENTIFIC": "Scientific Calculator",
    "DESMOS_FOURFUNCTIOM": "Function Calculator",
    "DESMOS_GEOMETRY": "Geometry",
    "AUTODRAW": "Autodraw",
    "MAIN_TOOLBAR_SHARE_CLASSROOM": "Share on Google Classroom",
    "MAIN_TOOLBAR_SHARE-FB": "Share on Facebook",
    "MAIN_TOOLBAR_SHOWHELP_ADD": "click on node to add a step",
    "MAIN_TOOLBAR_SHOWHELP_REMOVE": "click the number to remove the step",
    "MAIN_TOOLBAR_SPEECHEDIT": "Speech edit",
    "MAIN_TOOLBAR_STARTSHOW": "Start",
    "MAIN_TOOLBAR_TEXT-TO-SPEECH-ENABLE": "Enable text to speech",
    "MAIN_TOOLBAT_TEXT-TO-SPEECH-DISABLE": "Disable text to speech",
    "MAIN_TOOLBAR_UNDO": "Undo",
    "MAIN_TOOLBAR_ZOOM-FIT": "Fit map",
    "MAIN_TOOLBAR_ZOOM_IN": "Zoom in",
    "MAIN_TOOLBAR_ZOOM_OUT": "Zoom out",
    "MAIN_TOOLBAR_ZOOM_SELECTION": "Zoom on selection",
    "MANAGE_SHARINGS_MAP": "Advanced sharing",
    "MAP_AUTH": "Auth",
    "MAPEDIT_ERROR_GENERIC_MAP_LOAD": "Can't open the map",
    "MAPEDIT_LOADING": "Loading...",
    "MAPEDIT_TITLE": "Map",
    "MAP_DELETEDATE": "Deletion",
    "MAP_LASTUPDATE": "Last update",
    "MAP_NAME": "Name",
    "MAP_PUBLIC": "public",
    "MAPSHARED_TITLE": "Map",
    "MAP_SHARING": "Sharing",
    "MAPVIEW_TITLE": "Map",
    "MATH_OK": "Confirm",
    "MATH_CANCEL": "Empty",
    "MATH_LATEX": "LaTeX",
    "MATH_LATEX_INFO": "Information about using LaTeX",
    "MATH_LATEX_INFO_MESSAGE": "<div><b>To enter LaTeX mode</b><br/>Press the <b>LaTeX</b> button on the toolbar or the <b>\\</b> key on the keyboard.</div><br/><div><b>How to obtain suggestions</b><br/>When in LaTeX mode, press the <b>\\</b> key on the keyboard and start writing LaTeX.</div><br/><div><b>How to select a suggestion</b><br/>Move the cursor on the various suggestions with <b>arrow keys</b> then press <b>TAB</b> to insert the selected suggestion into the current formula.</div><br/><div><b>How to exit LaTeX mode</b><br>There are different ways: <ul><li>Press the <b>LaTeX</b> button on the toolbar</li><li>Press the <b>ESC</b> key on the keyboard</li><li>Press the <b>HOME</b> key on the keyboard</li></ul></div>",
    "MATH_CLOSE": "Close",
    "MATH_ERROR_FORMULA": "Error in formula",
    "MATH_ERROR_FORMULA_PLACEHOLDER": "One or more placeholders need to be filled.",
    "MATH_ERROR_IMAGE": "Error generating the image",
    "MAX_ERROR": "The maximum number of users that can be enabled is 500",
    "MIN_ERROR": "The number of allowed users is lesser than the assigned users.",
    "MODALITY": "Modality",
    "MOVE_HERE": "Move to",
    "MOVE_MAPS": "Move maps",
    "MOVE_MAPS_OLDUSER": "Old user ID (from)",
    "MOVE_MAPS_NEWUSER": "New user ID (to)",
    "MSG_ASK_CHANGE_NODE_DOC": "The node already contains text or image. Do you want to change it with document contents?",
    "MSG_ASK_CHANGE_NODE_LINK": "The node already contains text or image. Do you want to change it with link contents?",
    "MSG_ASK_CHANGE_NODE_MAP": "The node already contains text or image. Do you want to change it with map contents?",
    "MSG_ASK_CHANGE_NODE_NO": "Update the node",
    "MSG_ASK_CHANGE_NODE_YES": "Attachment only",
    "MSG_CONFIRM_UPDATE_DOCFILE_TITLE": "Update document",
    "MSG_CONFIRM_UPDATE_DOCFILE_MESSAGE": "Do you want to update the generate document?<br>All previous changes in the document will be lost.",
    "MSG_DOCFILE_CREATED": "Document has been created",
    "MSG_DOCFILE_UPDATED": "Document has been updated",
    "MSG_MAP_DOES_NOT_EXIST": "This map has never been opened in Smxstudio. You have to open it first to use as a link.",
    "MSG_NO_VIDEOREC_SUPPORTED": "The video recorder is only supported on <b>Windows</b>.",
    "MSG_MISSING_PRIVACY_TEXT": "You have not yet given consent to the processing of personal data.<br>Press Ok to log in again and be sure to fill in the privacy consent form.",
    "MSG_MISSING_PRIVACY_TITLE": "Privacy missing",
    "MSG_OCRSCAN_OK": "Scan ok.",
    "MSG_OCRSCAN_NO_SCANS_LEFT": "You have no more scans left.",
    "MSG_OCRSCAN_ERROR_SEARCH_SCANCOUNT": "Error searching scan counter.",
    "MSG_OCRSCAN_ERROR_DECREASE_SCANCOUNT": "Error decreasing scan counter.",
    "MSG_OCRSCAN_ERROR_MATHPIX": "Error during server call.",
    "MSG_OCRSCAN_GENERIC_ERROR": "Generic OCR error.",
    "OCRSCAN": "Math OCR",
    "OCRSCAN_WAIT": "Image is loading, Please wait...",
    "OCRSCAN_LEFT_PERSONAL_N": "You have %n scans left",
    "OCRSCAN_LEFT_GROUP_N": "Your workgroup has %n scans left",
    "OCRSCAN_LEFT_PERSONAL_1": "You have %n scan left",
    "OCRSCAN_LEFT_GROUP_1": "Your workgroup has %n scan left",
    "OCRSCAN_PERIOD_MONTH": "for the current month",
    "OCRSCAN_PERIOD_ALL": "in total",
    "OCRSCAN_POLICY_FREE": "in total",
    "OCRSCAN_POLICY_MONTHLY": "monthly for the workgroup",
    "OCRSCAN_POLICY_MONTHLY-USER": "monthly for each user of the group",
    "OCRSCAN_LEFT": "OCR Scans left",
    "OCRSCAN_OVER": "You have no more scans left",
    "MSG_USER_CANT_SHARE": "You don't have permission to share this map",
    "MSG_VIDEOREC_INFO_01": "SMX Studio Video Recorder",
    "MSG_VIDEOREC_INFO_02": "Recording video service and cloud space are supplied by <a href='https://www.apowersoft.com/', target='_blank'>Apowersoft Ltd</a>.",
    "MSG_VIDEOREC_INFO_03": "Anastasis does not give assistance or guarantees on this service.",
    "MSG_VIDEOREC_INFO_04": "To use this video recorder you need to <b>install the launcher</b>.",
    "MSG_VIDEOREC_INFO_05": "1. Click [<b>Record video</b>] to start the recorder.",
    "MSG_VIDEOREC_INFO_06": "2. <i>Customize</i> recording modes, then click [<b>REC</b>] to start recording.",
    "MSG_VIDEOREC_INFO_07": "3. When you're done, click on [<b>STOP</b>] button and [<b>SAVE</b>] the video.",
    "MSG_VIDEOREC_INFO_08": "You can find more information about using the video recorder in SMX Studio manual.",
    "MSG_VIDEOREC_SUB_01": "Full screen",
    "MSG_VIDEOREC_SUB_02": "Area",
    "MSG_VIDEOREC_SUB_03": "System audio",
    "MSG_VIDEOREC_SUB_04": "Webcam",
    "NEW_MAP_NAME": "New map",
    "NEW_MAP": "New map",
    "CREATE_NEW_MAP": "Create new map",
    "NEWSLETTER_CONTENT_1": "<h2><b>Subscribe to the newsletter</b></h2>",
    "NEWSLETTER_CONTENT_2": "Subscribe to the newsletter to stay updated on the latest Anastasis news.",
    "NEWSLETTER_DIALOG_TITLE": "Subscribe to the newsletter",
    "NEWSLETTER_INFO": "Info about the newsletter",
    "NEXT_PAGE_LABEL": "Next page",
    "NEXT_PAGE": "Next page",
    "NOBROWSER_TITLE": "Incompatible browser",
    "NOCOLOR": "No color",
    "NO_GOOGLE_TITLE": "Can't access Google login",
    "NO_GOOGLE_MESSAGE_1": "This service is unavailable for users who are under 13 that are managed by parents using Family Link.",
    "NO_GOOGLE_MESSAGE_2": "To solve this problem use an account that is not linked to a Family Link.",
    "NO_MAP_NAME": "Insert map name",
    "NO_MAPS": "No maps yet",
    "NO_NOTIFICATIONS": "is empty",
    "NO_SUBSCRIPTIONS": "No subscriptions found",
    "NOT_A_GOOGLE_EMAIL_MSG": " is not a Google email.",
    "NOTEPAD_READONLY": "Notepad is read only",
    "NOTES": "Notes",
    "NOTIFICATION_CHECK": "Show",
    "NOTIFICATION_DATE": "Event date",
    "NOTIFICATION_DESC": "Description",
    "NOTIFICATION_DESC_PLACEHOLDER": "Insert notification description",
    "NOTIFICATION_EXPIRING_ACCOUNT": "Your subscription is about to expire",
    "NOTIFICATION_EXPIRING_DEMO": "Your demonstration is about to expire",
    "NOTIFICATION_EXPIRED_ACCOUNT": "Your subscription has expired",
    "NOTIFICATION_EXPIRED_DEMO": "Your demonstration has expired",
    "NOTIFICATION_INSERT": "Insert notification",
    "NOTIFICATION_LINK": "Link",
    "NOTIFICATION_MANAGEMENT": "Notification management",
    "NOTIFICATIONS_EMPTY": "No notifs",
    "NOTIFICATIONS_INFO": "You will receive information on updates, training ...",
    "NOTIFICATIONS_LIST": "Notifs List",
    "NOTIFICATIONS": "Notifs",
    "NOTIFICATION_TITLE_PLACEHOLDER": "Insert notification title",
    "NOTIFICATION_TITLE": "Title",
    "NOTIFICATION_TYPE": "Type",
    "NOT_OWNER_CANT_CREATE_GOOGLEDOC": "Only map owner can generate the Google Document",
    "NOT_VALID_DOMAINLICS_MSG": " is not a valid user number.",
    "NOT_VALID_DOMAIN_MSG": " is not a valid domain.",
    "NOT_VALID_EMAIL_MSG": " is not a valid email.",
    "NUM_COL": "Number of columns",
    "NUM_ROW": "Number of rows",
    "OCR_SCANS_LEFT": "Scans left",
    "OCR_LATEX_EMPTY": "No math formula recognized",
    "OFFLINE_GENERIC": "Don't work without connection",
    "OFFLINE_LOGIN": "Cannot log in without connection",
    "OFFLINE_RECENT": "No recents resource without connection",
    "OFFLINE_STATUS": "Disconnected! The map will be saved as soon as the connection returns",
    "OK": "Ok",
    "OOOPS": "Whoops!",
    "OOPS": "Whoops!!!",
    "OPEN_FROM_GDRIVE": "Import from Drive",
    "OPEN_FROM_LOCAL": "Upload map",
    "OPEN_PDF": "Upload Pdf",
    "OPEN_GOOGLE_DOC": "Open Google Doc",
    "OPEN_IN_NEW_WINDOW": "Open in new window",
    "OPEN_INTRO_MAP": "Open tutorial map",
    "ORDER-CREATEDBY": "Order created by",
    "ORDER-CREATIONDATE": "Order creation date",
    "ORDER-DOMAINLICS": "Domain users number",
    "ORDER-EXPIREDATE": "Expiry date",
    "ORDER-EXPIRED": "Subscription has expired and you cannot configure it.",
    "ORDER-FULLNAME": "Buyer name",
    "ORDER-LASTMODIFICATIONBY": "Last modification by",
    "ORDER-LASTMODIFICATIONDATE": "Last modification date",
    "ORDER-LICENSETYPE": "License type",
    "ORDER_MODIFIED": "Order changed successfully",
    "ORDER-NETWORKUSERID": "User ID",
    "ORDER-NOTES": "Order notes",
    "ORDER-NOTFOUND-LINE1": "This subscription does not exist",
    "ORDER-NOTFOUND-LINE2": "This subscription has been disabled",
    "ORDER-NOTFOUND-LINE3": "Limited or missing network connectivity",
    "ORDER-NOTFOUND-LINE4": "Subscription security code does not match",
    "ORDER-NOTFOUND-SUB": "Possible causes are:",
    "ORDER-NOTFOUND-TITLE": "You cannot configure this subscription",
    "ORDER-ORDERID": "Order ID",
    "ORDER-ORIGIN": "Order origin",
    "ORDER-REFORDERID": "Previous order ID",
    "ORDER-SLOTCOUNT": "Users number",
    "ORDER-SUBMITTED-SUB": "Now you may close this tab",
    "ORDER-SUBMITTED-TITLE": "Subscription edit successful",
    "ORDER-SUSPENDED": "Subscription has been deactivated and you cannot configure it.",
    "ORDER-USEREMAIL": "Buyer email",
    "ORDER-HISTORY-TITLE": "History for order #",
    "ORDER-HISTORY-DATE": "Date:",
    "ORIGIN_AID": "AID entry",
    "ORIGIN_ALL": "--- All orders ---",
    "ORIGIN_APP-STORE": "App Store",
    "ORIGIN_AZIONE-SMX-2020-2021": "Action SMX 2020-2021",
    "ORIGIN_AZIONE-SMX-2021-2022": "Action SMX 2021-2022",
    "ORIGIN_BUY": "Purchase",
    "ORIGIN_DEMO": "Demo",
    "ORIGIN_DOPOSCUOLA": "Afterschool",
    "ORIGIN_DS-SCUOLA-2020": "DS Adopt a school 2020",
    "ORIGIN_FAD": "FAD",
    "ORIGIN_MANUAL": "Manual entry",
    "ORIGIN_RETE-ANA-SCUOLA": "Anastasis centre network-SCHOOL",
    "ORIGIN_PIEM-SPAOLO-2021": "Piemonte-Fond.S.Paolo 2021",
    "ORIGIN_PLAY-STORE": "Play Store",
    "ORIGIN_SMX-SCUOLE-2022": "SMX Schools 2022",
    "ORIGIN_SPAIN": "Spain",
    "ORIGIN_USR-ER": "Reg.school office Emilia Romagna",
    "ORIGIN_WEBINAR": "Webinar",
    "OTHER": "Other",
    "OUTLINE": "Outline",
    "OUTLINE_ADD_ABOVE": "Add sibling",
    "OUTLINE_ADD_BELOW": "Add child",
    "OUTLINE_DELETE": "Delete node and children",
    "OUTLINE_EDIT": "Edit",
    "OUTLINE_UP": "Move up",
    "OUTLINE_DOWN": "Move down",
    "OUTLINE_IN": "Move in",
    "OUTLINE_OUT": "Move out",
    "OUTLINE_COPY": "Copy",
    "OUTLINE_PASTE": "Paste",
    "OUTLINE_TITLE": "New node",
    "OUTLINE_SELECT_SUBTREE": "Select all subtree",
    "OUTLINE_QUICK_INPUT": "Quick input",
    "OUTLINE_READONLY": "Outline is read only",
    "OUTLINE_TOOLTIP_DROP_PARENT": "Move out",
    "OUTLINE_TOOLTIP_DROP_SIBLING": "Become sibling",
    "OUTLINE_TOOLTIP_DROP_CHILD": "Become child",
    "OUTLINE_ARRANGE": "Arrange map",
    "OUTLINE_ARRANGE_TABLE": "Table",
    "OUTLINE_NODE_VIEW_IMAGE_SHOW": "Show images",
    "OUTLINE_NODE_VIEW_IMAGE_HIDE": "Hide images",
    "OUTLINE_WARNING_1": "Included",
    "OUTLINE_WARNING_2": " until January 2024!",
    "PAGE_BACK": "Page back",
    "PASTE_HERE": "Open context-menu and paste here",
    "PASTE-OPTIONS": "PASTE OPTIONS",
    "PASTE-AS-TABLE": "PASTE AS TABLE",
    "PASTE-AS-NODE": "PASTE AS NODE",
    "PASTE-AS-MAP": "PASTE AS MAP",
    "PASTE-AS-DEEP": "Paste text in brackets (...) as deep text",
    "PASTE-OPTIONS-TAB": "single",
    "PASTE-OPTIONS-COLUMNS": "columns",
    "PASTE-OPTIONS-ROWS": "rows",
    "PASTE-OPTIONS-ONE-NODE": "single node",
    "PASTE-OPTIONS-MANY-NODES": "many nodes",
    "PASTE-OPTIONS-ONE-COLUMN": "one column",
    "PASTE-OPTIONS-ONE-ROW": "one row",
    "PASTE-OPTIONS-NODES-VERT": "nodes vertically",
    "PASTE-OPTIONS-NODES-HORIZ": "nodes horizontally",
    "PASTE-OPTIONS-MAP-UPDOWN": "tree",
    "PASTE-OPTIONS-MAP-RADIAL": "radial",
    "PASTE-OPTIONS-MAP-LEFTRIGHT": "tree from left",
    "PASTE-OPTIONS-MAP-DOWNUP": "tree from bottom",
    "PASTE-OPTIONS-MAP-RIGHTLEFT": "tree from right",
    "PLAY": "Play",
    "PLAY_SPEED": "Play speed",
    "PLEASE_WAIT": "Working, please wait...",
    "PREF_COLOR": "Color",
    "PREF_DEEP": "Deep content",
    "PREF_EDGE": "Arrows",
    "PREF_EFFECT_BOLD": "bold",
    "PREF_EFFECT_NONE": "none",
    "PREF_EFFECTS": "Effects",
    "PREF_TEXT_TITLE": "Text",
    "PREF_FONT": "Font",
    "PREF_NODE_TITLE": "Node",
    "WITH_FRAME": "with frame",
    "WITHOUT_FRAME": "without frame",
    "PREF_NODE_IMAGE": "Node image",
    "PREF_DESC_NODE_IMAGE": "Choose whether to have the frame of the image nodes. The frame of an image node can only be rectangular.",
    "PREF_NOTE": "Notes",
    "PREF_MATH": "Mathematics",
    "PREF_RESET_MESSAGE": "Restore default values?",
    "PREF_RESET": "Restore defaults",
    "PREF_SIZE": "Size font",
    "PREF_ASPECT_TITLE": "Aspect",
    "PREF_SHAPE": "Shape",
    "PREF_SHAPE_RECT": "Rectangle",
    "PREF_SHAPE_ELLIPSE": "Ellipse",
    "PREF_SHAPE_ROUNDRECT": "Rounded",
    "PREF_BACKGROUND_COLOR": "Background color",
    "PREF_BORDER_COLOR": "Border color",
    "PREF_NODE_IMAGE_TITLE": "Node image",
    "PREF_EDGE_WIDTH": "Width",
    "PREF_EDGE_TYPE": "Type",
    "PREF_DESC_FREE_EDGE": "The curvature of the free arrow can be changed manually",
    "FREE_EDGE": "Free edge",
    "PREF_EDGE_STRAIGHT": "Straight",
    "PREF_EDGE_CURVE": "Curve",
    "PREVIOUS_PAGE_LABEL": "Previous page",
    "PREV_PAGE": "Previous page",
    "PREVIEW_NOT_AVAILABLE": "Preview not available",
    "PRIVACY_AGE_REQUEST": "Please select your age range",
    "PRIVACY_AGE_OVER_18": "I have more than 18 years",
    "PRIVACY_AGE_UNDER_18": "I have less than 18 years",
    "PRIVACY_CONFIRM": "Yes, confirm",
    "PRIVACY_HEADER": "<h1><b>One more moment...</b></h1><div><p>We care about your privacy and use your data only if it is strictly necessary for Smxstudio to work.</p></div><div><p>Before we go any further, we want to make sure that your rights and obligations regarding your data and content that you will insert into Smxstudio are clear.</p></div><div><p>If Smxstudio is used by a minor, the following declarations must be read and accepted by those who have parental responsibility.<br /> <p style='color: red'>* indicates required fields</p></p></div><br/>",
    "PRIVACY_CONTENT_GENERIC": "<h2><b>Privacy Policy</b></h2><div><p>I confirm that I have read the %privacypolicy% and I express my free consent to the processing of personal data, as specified in the aforementioned policy.</p></div>",
    "PRIVACY_CONTENT_PRIVATE_EDU_LINK": "<a href='https://privacy.SMX studio.it/edu/smx-edu-privacy-scuole.pdf' target='_blank'>Privacy policy of Smxstudio EDU for privates</a>",
    "PRIVACY_CONTENT_SCHOOL_EDU_LINK": "<a href='https://www.anastasis.it/SMX studio/privacy-scuole.pdf' target='_blank'>Privacy policy of Smxstudio EDU for schools</a>",
    "PRIVACY_CONTENT_UNIVERSITY_EDU_LINK": "<a href='hhttps://privacy.SMX studio.it/edu/smx-edu-privacy-universita.pdf' target='_blank'>Privacy policy of Smxstudio EDU for universities</a>",
    "PRIVACY_CONTENT_PRIVATE_LAB_LINK": "<a href='https://privacy.SMX studio.it/lab/smx-lab-privacy-privati.pdf' target='_blank'>Privacy policy of Smxstudio LAB for privates</a>",
    "PRIVACY_CONTENT_SCHOOL_LAB_LINK": "<a href='https://privacy.SMX studio.it/lab/smx-lab-privacy-scuole.pdf' target='_blank'>Privacy policy of Smxstudio LAB for schools</a>",
    "PRIVACY_CONTENT_UNIVERSITY_LAB_LINK": "<a href='https://privacy.SMX studio.it/lab/smx-lab-privacy-universita.pdf' target='_blank'>Privacy policy of Smxstudio LAB for universities</a>",
    "PRIVACY_PURPOSE": "Purpose of the processing",
    "PRIVACY_PURPOSE_A": "a) creation of an account for access to the platform and use of the Smxstudio %planId% service for the creation and sharing of multimedia concept maps, in the context of inclusive and collaborative teaching (as provided for in art. 6 letter b GDPR).",
    "PRIVACY_PURPOSE_B": "b) the fulfillment of the legal obligations established by the legal regulations for the requirements established by the fiscal and tax legislation. The legal basis of the processing is the fulfillment of a legal obligation (as provided for in art. 6 letter c) GDPR).",
    "PRIVACY_PURPOSE_C": "c) to allow navigation, registration and access, the legitimate interest of the Data Controller in making navigation usable and safe (art. 6, par. 1 letter f of EU Regulation 2016/679) and to ascertain, exercise or defense of a right in court and out of court (legitimate interest) of the undersigned organizations (art. 6, par. 1 letter f) EU Regulation 2016/679).",
    "PRIVACY_DOC_DPA": "I declare that I have read and accepted the terms reported in the document <a href='https://www.anastasis.it/SMX studio/dpa.pdf' target='_blank'>Discipline of the processing of personal data</a>.",
    "PRIVACY_DOC_CONTRACT_GENERIC": "I declare that I have read and accepted the terms reported in the document %contract%.",
    "PRIVACY_DOC_CONTRACT_PRIVATE_EDU": "<a href='https://privacy.SMX studio.it/edu/smx-edu-contratto-privati.pdf' target ='_blank'>IT services contract for access to the Smxstudio for privates platform</a>",
    "PRIVACY_DOC_CONTRACT_SCHOOL_EDU": "<a href='https://privacy.SMX studio.it/edu/smx-edu-contratto-scuole.pdf' target ='_blank'>IT services contract for access to the Smxstudio for schools platform</a>",
    "PRIVACY_DOC_CONTRACT_UNIVERSITY_EDU": "<a href='https://privacy.SMX studio.it/edu/smx-edu-contratto-universita.pdf' target ='_blank'>IT services contract for access to the Smxstudio for universities platform</a>",
    "PRIVACY_DOC_CONTRACT_PRIVATE_LAB": "<a href='https://privacy.SMX studio.it/lab/smx-lab-contratto-privati.pdf' target ='_blank'>IT services contract for access to the Smxstudio for privates platform</a>",
    "PRIVACY_DOC_CONTRACT_SCHOOL_LAB": "<a href='https://privacy.SMX studio.it/lab/smx-lab-contratto-scuole.pdf' target ='_blank'>IT services contract for access to the Smxstudio for schools platform</a>",
    "PRIVACY_DOC_CONTRACT_UNIVERSITY_LAB": "<a href='https://privacy.SMX studio.it/lab/smx-lab-contratto-universita.pdf' target ='_blank'>IT services contract for access to the Smxstudio for universities platform</a>",
    "PRIVACY_DOC_TITLE": "Contract and Terms of Service acceptance",
    "PRIVACY_ERROR": "Required",
    "PRIVACY_NEWSLETTER_CONFIRM": "Yes, I'd like to subscribe to the newsletter",
    "PRIVACY_NEWSLETTER_INFO": "<a href='' target='_blank'></a>Sending the informative newsletter and any commercial information relating to Anastasis services and products, through specific online campaigns. The sending of these communications is reserved for users who declare that they have reached the age of 18.<br>For this purpose we ask you to give specific consent which can always be withdrawn by unsubscribing through the link in the communications received or by writing to the email address: <a href='mailto:privacy@anastasis.it' target='_blank'>privacy@anastasis.it</a><br><br>In the case of consent given by a minor, pursuant to art. 2 quinquies of Legislative Decree 196/2003 and 8 par 1 of EU Reg. 679/2016, please note that consent is validly expressed only if the same minor is over 14 years old.<br>Otherwise, consent must be given by the parent or tutor.<br><br>For sending such communications, we use Mailchimp, a platform that uses the GDPR standards for data protection.<br>For more information: <a href='https://mailchimp.com/legal/privacy' target='_blank'>mailchimp.com/legal/privacy</a>",
    "QRCODE_TITLE_GDOC": "Scan to open Google Document",
    "QRCODE_TITLE_MAP": "Scan to open map",
    "QUICKEDIT_TOOLBAR_MSG": "Quick edit enabled",
    "RACU_LINK": "https://www.anastasis.it/contatti/",
    "RACU_LINK_TEXT": "Customer Service",
    "RACU_TEXT_01": "This kind of subscription cannot be renewed with automated process.",
    "RACU_TEXT_02": "Please renew your afterschool agreement",
    "RACU_TEXT_03": "or contact our",
    "RACU_TITLE": "Afterschool subscription renewal",
    "RANGE_PAGE_LABEL_1": "0 of {{length}}",
    "RANGE_PAGE_LABEL_2": "{{page}} of {{length}}",
    "RCU_LINK": "https://www.anastasis.it/contatti/",
    "RCU_LINK_TEXT": "Customer Service",
    "RCU_TEXT_01": "This kind of subscription cannot be renewed with automated process.",
    "RCU_TEXT_02": "To renew, please contact our",
    "RCU_TITLE": "Subscription renewal",
    "READONLY_MAP": "Read only map",
    "READ_ONLY": "read only",
    "READ_TITLE": "Read",
    "RECENT_COPY_PLUR": "copies",
    "RECENT_COPY_SING": "copy",
    "RECENT_MAPS": "All maps",
    "RECENT_MENU_CREATECOPY": "Create copy",
    "RECENT_MENU_DOWNLOAD": "Download",
    "RECENT_MENU_REMOVE": "Remove from recents",
    "RECENT_MENU_RENAME": "Rename",
    "RECENT_TOOLBAR_SHOW-LIST": "show list",
    "RECENT_TOOLBAR_SHOW-PREVIEWS": "show previews",
    "RECENT_TOOLBAR_SORT-ALPHABETIC": "alphabetic",
    "RECENT_TOOLBAR_SORT-DATE": "by date",
    "RECENT_TOOLBAR_SORT": "Order by",
    "RECENT_VIEW_PLUR": "views",
    "RECENT_VIEW_SING": "view",
    "RECVIDEO_BUTTON": "Record video",
    "REFORDERID_NEW": " (new)",
    "REFORDERID_RENEW": " (renewed)",
    "REFORDERID_UPDATE": " (modified)",
    "RELOAD_PAGE": "Reload page",
    "RENAME_RECENT_MAP": "Rename",
    "REPORT_GEN": "Jan",
    "REPORT_FEB": "Feb",
    "REPORT_MAR": "Mar",
    "REPORT_APR": "Apr",
    "REPORT_MAG": "May",
    "REPORT_GIU": "Jun",
    "REPORT_LUG": "Jul",
    "REPORT_AGO": "Aug",
    "REPORT_SET": "Sep",
    "REPORT_OTT": "Oct",
    "REPORT_NOV": "Nov",
    "REPORT_DIC": "Dec",
    "REPORT_ACTIVESTUDENTS": "YOUR ACTIVE STUDENTS THIS MONTH",
    "REPORT_ADMIN_TITLE": "Admin stats",
    "REPORT_CLASSROOM": "on Google Classroom",
    "REPORT_CLASSROOM_TITLE": "Classroom stats",
    "REPORT_COPIES": "Copies",
    "REPORT_CREATEDMAPS1": "You created",
    "REPORT_CREATEDMAPS2": "maps created",
    "REPORT_DETAIL": "Detail",
    "REPORT_DONE": "What you did with your maps",
    "REPORT_EXPORT": "From map",
    "REPORT_FACEBOOK": "on Facebook",
    "REPORT_GOOGLEDOCS1": "You created",
    "REPORT_GOOGLEDOCS2": "Google documents",
    "REPORT_GOTOREPORT": "go to Report",
    "REPORT": "WORKGROUPS",
    "REPORT_IMAGES": "Images",
    "REPORT_INSERT": "MAPS",
    "REPORT_LINK": "as link",
    "REPORT_LINK_QRCODE": "link/QRcode",
    "REPORT_LINKS": "Links",
    "REPORT_NEWMAPS": "New",
    "REPORT_NODES": "Nodes",
    "REPORT_OPENMAPS": "Opened",
    "REPORT_PRINTS2": "Prints",
    "REPORT_SHARES": "Shares",
    "REPORT_SHARING": "Shared maps",
    "REPORT_SHOW2": "Presentations",
    "REPORT_SOCIALS": "Where you shared your maps",
    "REPORT_STATORDER1": "your",
    "REPORT_STATORDER2": "students created",
    "REPORT_STATORDER3": "maps and opened ",
    "REPORT_STATS": "Stats",
    "REPORT_STUDENTS": "Students",
    "REPORT_STUDENTWORKS": "YOUR STUDENT WORKS",
    "REPORT_TABLES": "Tabes",
    "REPORT_USER_TITLE": "User stats",
    "REPORT_VIDEOS": "Videos",
    "REPORT_VIEWS": "Views",
    "REPORT_WORDS": "Words",
    "RESTORE_MESSAGE": "Map is trashed! Would you like restore it?",
    "RESTORE": "Restore",
    "RESTORE_TITLE": "Restore map",
    "ROLE_ADMIN": "Administrator",
    "ROLE_AID": "AID operator",
    "ROLE_ANASTASIS": "Anastasis operator",
    "ROLE_USER": "User",
    "ROTATE_LEFT": "Rotate left",
    "ROTATE_RIGHT": "Rotate right",
    "SAVE_TOOLTIP": "The changes are automatically saved in the drive",
    "SAVING_OTHER": "Now saving",
    "SAVING": "Saving in progress...",
    "SCHOOL_YEAR": "School year",
    "SEARCH_CLEAR": "Clear search",
    "SEARCH_CLOSE": "Close",
    "SEARCH_GOOGLE": "Search in Google",
    "SEARCH_GOOGLEIMG": "Search in Google image",
    "SEARCH_IMAGES": "Search images",
    "SEARCH_IN": "Search in",
    "SEARCH_IN_GOOGLE_IMAGE": "Search in Google images",
    "SEARCH_IN_MAP_PLACEHOLDER": "Search in map",
    "SEARCH_IN_WIKIPEDIA": "Search in Wikipedia",
    "SEARCH_IN_YOUTUBE": "Search on Youtube",
    "SEARCH_MAGIC": "Magic search",
    "SEARCH_MAP_PLACEHOLDER": "Search map...",
    "SEARCH_ON_WEB": "Search on web",
    "SEARCH_PLACEHOLDER": "Search...",
    "SEARCH_WIKIPEDIA": "Search in Wikipedia",
    "SEARCH_YOUTUBE": "Search on Youtube",
    "SELECT_FOLDER": "Select a folder",
    "SEND_MAIL": "Send email",
    "SHARED_EDIT": "Collaborative share",
    "SHARED_PUBLIC": "Publicly shared",
    "SHARED_VIEW": "Readonly share",
    "SHARE_LINK_COPY": "Copy in clipboard",
    "SHARE_LINK_EDIT": "Edit",
    "SHARE_LINK_LINK": "LINK",
    "SHARE_LINK_NONE": "With limitations",
    "SHARE_LINK_QRCODE": "QRcode",
    "SHARE_LINK_READONLY": "View only",
    "SHARE_LINK_REMOVE": "Remove access",
    "SHARE_LINK_SHARE_TYPE": "Public sharing settings",
    "SHARE_RECENT": "Share",
    "SHAREGROUP_FREQ": "Frequently used",
    "SHAREGROUP_GROUP": "Your workgroup",
    "SHAREMAP_ADD_USER": "Email to authorize",
    "SHAREMAP_PUBLIC": "Public access",
    "SHAREMAP_OWNER": "Owner",
    "SHAREMAP_TITLE": "Map sharing",
    "SHAREMAP_USER_ADD": "%username% shared with you the map \n<b>%mapname%</b>",
    "SHAREMAP_USER_DELETE": "%username% removed sharing for map \n<b>%mapname%</b>",
    "SHAREMAP_USERSLIST": "People to share",
    "SHAREMAP_WARNING_NOT_SHARED": "WARNING!\nThis map is currently shared with no one.\nIf you want to share it with someone remember to assign sharing rights.",
    "SHARING_MESSAGE_CANDO": "You can copy the link and view the QRcode",
    "SHARING_MESSAGE_EDIT": "If you share the map, anyone with the link can view",
    "SHARING_MESSAGE_VIEW": "The map is in VIEW only, you cannot share",
    "SHARING_STOPPED": "Public sharing stopped",
    "SHOW_DISABLED": "Showing only if map saved",
    "SHOWING": "Presentation mode",
    "SHOW_STATS": "Show stats",
    "SHOW_TOOLBAR_NEXT": "Next step",
    "SHOW_TOOLBAR_PREV": "Previous step",
    "SIZE_TOOLBAR-BOTH": "All equal",
    "SIZE_TOOLBAR-HEIGHT": "Same height",
    "SIZE_TOOLBAR-SIZE": "Resize",
    "SIZE_TOOLBAR-WIDTH": "Same width",
    "SPEECHEDIT_TOOLBAR_MSG": "Speech edit enabled",
    "START_DATE": "Starting date",
    "STAT_ADDIMAGE": "Images",
    "STAT_ADDLINK": "Link",
    "STAT_ADDNODE": "Nodes",
    "STAT_ADDTABLE": "Tables",
    "STAT_ADDVIDEO": "Videos",
    "STAT_COPYSHARED": "Copies",
    "STAT_NEWMAP": "Maps",
    "STAT_OPENMAP": "Opened",
    "STAT_SHARELINK": "Shared maps",
    "STAT_VIEWSHARED": "Views",
    "STAT_WORDS": "Words",
    "STOP_SHARING_MAP": "Stop public sharing",
    "STOP": "Stop",
    "SUBSCRIPTION": "Subscription",
    "SUBSCRIPTION_NOTES": "Operator notes",
    "SUBSCRIPTIONS_LIST": "Subscriptions",
    "SUSPEND_SUBSCRIPTION": "Deactivate subscription",
    "TABLE_MAXCOLROW": "Columns and row must be a value between 2 and 10 ",
    "TABLE_TOOLBAR-ADD-COL-AFTER": "Add column after",
    "TABLE_TOOLBAR-ADD-COL-BEFORE": "Add column before",
    "TABLE_TOOLBAR-ADD-ROW-ABOVE": "Add row above",
    "TABLE_TOOLBAR-ADD-ROW-BELOW": "Add row below",
    "TABLE_TOOLBAR-REMOVE-COL": "Delete column",
    "TABLE_TOOLBAR-REMOVE-ROW": "Delete row",
    "TABLE_TOOLBAR-REMOVE-TABLE": "Remove table",
    "TABLE_TOOLBAR-LOCK": "Lock table",
    "TABLE_TOOLBAR-UNLOCK": "Unlock table",
    "TABLE_WARNING_EXTENDED": "Table contains {%r} rows and {%c} columns. Confirm paste?",
    "TABLE_WARNING_TOOBIG": "Table contains {%r} rows and {%c} columns and it's too big ti be pasted. Do you want to paste its content in a single node?",
    "TEST": "TEST",
    "TEXT_NO_MAPS": "Create new ones or open existing ones",
    "TITLE_COPY_MAP": "Copy map",
    "TITLE_OPEN_MAP": "Open map",
    "TITLE_RENAME_MAP": "Rename map",
    "UPDATE": "Update",
    "UPDATE_GOOGLE_DOC": "Update Google Doc",
    "USERDESKTOP_TITLE": "User's Configuration",
    "USER_EXPIRED": "Subscription is expired",
    "USER_IS_ME": " (you)",
    "USER_IS_NOT_OWNER": "This map has been made by someone else",
    "USER_IS_OWNER": "You are the author of the map",
    "USERS_LIST": "Users list",
    "USERS_MANAGEMENT": "Users management",
    "USERS_DELETE": "Delete user",
    "USER_DELETED": "User deleted:",
    "USER_DELETE_FAIL": "Whoops! Something went wrong, user not deleted:",
    "USER_DELETE_SHORT": "Type at least 3 chars to search for users",
    "USERS_LIST_INCOMPLETE": "Users list incomplete",
    "CONFIRM_USERS_DELETE": "This operation will remove the user from Firebase and also all related data. Are you sure you want to delete this user?",
    "VERSION": "Version",
    "VIEW_MODE": "View",
    "WAIT": "Wait",
    "WARNING": "Warning",
    "WARNING_STOP_SHARING": "Removing the map from the recents, the sharing will be stopped.",
    "WEBINAR": "Webinar",
    "WIKIPEDIA": "Wikipedia",
    "WRONG_PARAMS": "Some mandatory param is missing",
    "YOUTUBE": "Youtube",
    "storageQuotaExceeded": "The user's Drive storage quota has been exceeded.",
    "insufficientFilePermissions": "The user does not have sufficient permissions for file",
    "access_denied": "Access denied",
    "INSERT_TEXT": "Insert text",
    "CAPTURE": "Capture image",
    "CAPTURE_INFO": "Drag the mouse over the notepad to cut out an image",
    "CAPTURE_MATH": "Capture mathematical formula",
    "DRAW_TITLE": "Draw",
    "VOICES": "Voices",
    "TITLE_BLOCKNOTES": "Untitled notes",
    "DROP_PDF": "drag and drop the pdf here",
    "INSERT_LINK_PDF": "or insert link",
    "IMPORTS_PDF": "Load PDF",
    "FROM_GD": "From Google Drive",
    "FROM_LINK": "From link",
    "CHANGE_COLOR": "Change color",
    "OPEN_RECENT_MAP": "Open recent",
    "OPEN": "Open",
    "MY_PDF": "My PDF",
    "PDF_DELETE": "Delete",
    "PDF_PLACEORDER": "Paste here PDF link",
    "CONFIRM_DELETE_PDF": "Do you confirm the deletion of the document?",
    "CONFIRM_RESTORE_PDF": "The pdf has been deleted. Do you want to recover it?",
    "CONFIRM_RELOAD_PDF": "he PDF was edited in another session<br>and will be updated to the latest version.",
    "MATH_PRIMARY_KEYBOARD": "Primary",
    "MATH_BASIC_KEYBOARD": "Base",
    "MATH_SETS_KEYBOARD": "Sets and logic",
    "MATH_GEOMETRY_KEYBOARD": "Geometry",
    "MATH_DISEQUATIONS_KEYBOARD": "Disequations",
    "MATH_PHYSICS_KEYBOARD": "Physics",
    "MATH_ANALYSIS_KEYBOARD": "Analysis",
    "MATH_TRIGONOMETRY_KEYBOARD": "Trigonometry",
    "MATH_LOG_EXP_KEYBOARD": "Logarithms and Exponentials",
    "MATH_GREEK_KEYBOARD": "αβγ",
    "PREF_TITLE_MATH_KEYBOARD": "Select math keyboards",
    "PREF_DESC_MATH_KEYBOARD_TYPE_BASIC": "Keyboard suite for mathematical writings",
    "PREF_DESC_MATH_KEYBOARD_TYPE_PRIMARY": "Recommended keyboard for PRIMARY SCHOOL",
    "PREF_DESC_MATH_KEYBOARD_PREFS_1": "You can change this setting from",
    "PREF_DESC_MATH_KEYBOARD_PREFS_2": "File menu / Settings / Map / Mathematics",
    "PREF_MATH_KEYBOARD_TYPE_BASIC": "Advanced",
    "PREF_MATH_KEYBOARD_TYPE_PRIMARY": "Base",
    "PREF_MATH_KEYBOARDS": "Keyboards",
    "PREF_DESC_MATH_KEYBOARDS": "Choose which math keyboards to enable when entering a math formula into a node.",
    "COPY_LATEX": "Copy LaTeX",
    "COLOR": "Color",
    "BORDER_COLOR": "Border",
    "BRUSH": "Draw",
    "CIRCLE": "Circle",
    "LINE": "Line",
    "CHECK": "Check",
    "CONFIGPDF": "Annotation Configuration",
    "OPACITY": "Opacity",
    "COPY_UNDERLINE": "Copy underlined text",
    "COPY_HIGHLIGHT": "Copy highlighted text",
    "EXTRACT_PDF": "Extracte page",
    "PRINT_PDF": "Print PDF",
    "SIDEBAR_PDF": "Toggle sidebar",
    "VIEW_FIND_PDF": "Find in document",
    "AUTOMATIC_ZOOM": "Automatic zoom",
    "ACTUAL_SIZE": "Actual Size",
    "PAGE_FIT": "Page Fit",
    "PAGE_WIDTH": "Page Width",
    "PASTE_IN_NOTEPAD": "Paste in Notepad",
    "COPY_ON_NOTEPAD_MSG": "Text pasted in notepad",
    "TOAST_CLOSE": "Close",
    "INSERT_DEEP": "Insert in deep",
    "COPY_ON_DEEP_MSG": "Text in deep",
    "NO_NODE_SELECTED": "Select one node",
    "INVALID_PDF": "This file is not a valid PDF",
    "INVALID_URL": "Invalid url",
    "DRIVE_USAGE": "Storage space used",
    "USER_PROFILE_TITLE": "User profile",
    "CREATE_PROFILE": "Your Smxstudio profile",
    "CREATE_PROFILE_BUTTON": "Create profile",
    "RESET_PASSWORD": "Reset password",
    "FULLNAME": "Full name",
    "PASSWORD": "Password",
    "USERNAME": "Email",
    "CONFIRM_PASSWORD": "Confirm password",
    "CHOOSE_AVATAR": "Change photo",
    "DRIVE_QUOTA_EXCEEDED": "There is not enough space on Google Drive. Try freeing up some space and try again.",
    "AUTH_ERROR": "Invalid Credentials",
    "ACTIVE_ITEM_CREATION_LIMIT_EXCEEDED": "This account has exceeded the creation limit of 500 million items. To create more items, permanently delete some items.",
    "DAILY_LIMIT_EXCEEDED": "Daily Limit Exceeded",
    "FILE_OWNER_NOT_MEMEBER_OF_TEAM_DRIVE": "Cannot move a file into a shared drive as a writer when the owner of the file is not a member of that shared drive.",
    "INSUFFICIENT_FILE_PERMISSIONS": "The user does not have sufficient permissions for file",
    "DRIVE_HIERARCHY_DEPTH_LIMIT_EXCEEDED": "Your My Drive can't contain more than 100 levels of folders.",
    "STORAGE_QUOTA_EXCEEDED": "The user's Drive storage quota has been exceeded.",
    "TEAM_DRIVE_FILE_LIMIT_EXCEEDED": "The file limit for this shared drive has been exceeded.",
    "TEAM_DRIVE_MEMBERSHIP_REQUIRED": "The attempted action requires shared drive membership.",
    "USER_RATE_LIMIT_EXCEEDED": "User Rate Limit Exceeded.",
    "DRIVE_QUOTA_EXCEEDED_MESSAGE_MAPVIEW": "The user's Drive storage quota has been exceeded. To edit the map you need to free up storage space. Do you want to open the map in view only mode?",
    "ORDER_BY": "Order by",
    "ALL_MAPS": "All",
    "MY_MAPS": "Mine",
    "OTHERS_MAPS": "Other",
    "TRASH_BIN": "Trash",
    "REMOVE_AVATAR": "Remove photo",
    "LINK_WITH_GOOGLE": "Link with Google",
    "DISCONNECT": "Disconnect",
    "SIGNIN": "Sign in",
    "YOUR_EMAIL": "or login with your email",
    "FORGOT_PASSWORD": "Forgot password?",
    "PASSWORD_RECOVERY": "PASSWORD RECOVERY",
    "FORGOT_PASSWORD_MSG": "Enter your email address below, we will immediately send you the instructions to follow",
    "SEND": "Send",
    "REQUEST_RECOVERY_PASSWORD": "Request password recovery",
    "RESPONSE_RP_1": "We just sent you an email at ",
    "RESPONSE_RP_2": "%email% containing a link to set a new password.",
    "RESPONSE_RP_3": "You should receive this email within a few seconds. If not, please check your Spam/Junk emails.",
    "RESPONSE_RP_4": "If necessary you can also contact ",
    "GO_TO_HOME": "Return to homepage",
    "REGISTER_MSG": "We will check if you already have an account. If not, we will help you create one and activate a 30-day trial period, during which you will have access to all the features of Smxstudio",
    "GOON": "GO ON",
    "OPEN_FROM_DRIVE": "From Google Drive",
    "NO_DOCS_ALL": "THERE ARE NO MAPS... START CREATING!",
    "NO_DOCS_MINE": "THERE ARE NO MAPS",
    "NO_DOCS_OTHERS": "NO MAPS SHARED WITH YOU… YET!",
    "NO_DOCS_TRASH": "THE TRASH BIN IS EMPTY",
    "REQUEST_SIGNIN": "First Access",
    "RESPONSE_RS_1": "We just sent you an email at ",
    "RESPONSE_RS_2": "%email% containing a link to access to Smxstudio the first time.",
    "RESPONSE_RS_3": "You should receive this email within a few seconds. If not, please check your Spam/Junk emails.",
    "RESPONSE_RS_4": "If necessary you can also contact ",
    "INSERT_PASSWORD": "Insert your password",
    "LINK_ASSISTANCE": "technical assistance",
    "EDIT": "Edit",
    "AVATAR": "Avatar",
    "EDIT_PROFILE": "Your profile",
    "REENTER_EMAIL": "Please provide your email for confirmation",
    "TTS_SPEECHSYNTHESIS_TITLE": "Speech Synthesis",
    "TTS_ENABLED_SPEECHSYNTHESIS_MESSAGE": "Text to speech enabled",
    "TTS_SPEECHSYNTHESIS_ENABLE_REQUEST": "Do you want to enable Text-to-speech?",
    "GOOGLE_SIGNIN_MESSAGE": "This user is already present as Google user. Click Ok and login as Google contact.",
    "HEADER_ABOUT_DEVICE": "Device info",
    "EDIT_PASSWORD": "Edit password",
    "SET_PASS1": "The new password must meet these criteria:",
    "SET_PASS2": "at least 8 characters",
    "SET_PASS3": "at least 1 letter",
    "SET_PASS4": "at least one number or special character",
    "SET_PASS5": "Be careful not to include references to your email or your name and surname in your password, which are easily identifiable.",
    "HINT_OLD_PASSWORD": "Insert the old password",
    "HINT_NEW_PASSWORD": "Insert the new password",
    "HINT_REPEAT_PASSWORD": "Repeat new password",
    "ERR_SAVE_PASSWORD": "An error occurred while saving.",
    "ERR_OLD_PASSWORD": "The old password is incorrect.",
    "ERR_ONE_LETTER": "Attention! Must contain at least one letter.",
    "ERR_ONE_SYMBOL": "Attention! Must contain at least one special character.",
    "ERR_LENGTH_PASSWORD": "Attention! The password must be at least 8 characters.",
    "ERR_SAME_PASSWORD": "Attention! the new password is the same as the current one",
    "ERR_DIFFERENT_PASSWORD": "Attention! The two passwords do not match.",
    "SAVE": "Save",
    "UNKNOWN_USERNAME": "Unknown user",
    "EXPORT_IN_GOOGLE_DRIVE": "Export in Google Drive",
    "EXPORT_SUCCESS": "Export successful!",
    "PUBLIC_SHARE_LIMIT_ONLY_PERMISSION": "With limitations",
    "PUBLIC_SHARE_LIMIT_ANYONE_WITH_LINK": "Anyone with the link",
    "PUBLIC_SHARE_LIMIT_ONLY_PERMISSION_DESCRIPTION": "Only the users with access can open the document",
    "PUBLIC_SHARE_VIEW_ONLY_PERMISSION_DESCRIPTION": "All the users with the link can view the document",
    "PUBLIC_SHARE_EDIT_PERMISSION_DESCRIPTION": "All the users with the link can edit the document",
    "SHARE_COPY_LINK": "Copy link",
    "PREPARING_MAP": "Preparing map for Classroom...",
    "SHARE_SAVE_MESSAGE": "Share settings updated",
    "NOTIFICATIONS_FOOTER_BUTTON": "Show all notifications in the last 30 days",
    "REMOVE_RECENT_MAP": "Remove from list",
    "DELETE_RECENT_MAP": "Delete permamently",
    "TRASH_RECENT_MAP": "Move to trash",
    "UNTRASH_RECENT_MAP": "Restore",
    "MSG_TRASHED_MAP": "Map has been trashed",
    "MSG_UNTRASHED_MAP": "Map has been restored",
    "MSG_REMOVED_MAP": "Map has been removed from list",
    "MSG_DELETED_MAP": "Map has beed deleted",
    "TRASH_WARNING": "Maps in the trash bin will be automatically deleted after 90 days from deletion",
    "TRASH_EMPTY": "Empty recycle bin",
    "TRASH_EMPTY_CONFIRM": "Are you sure you want to empty recycle bin?\nYou will not be able to restore deleted maps.",
    "TRASH_EMPTIED": "The trash bin has been emptied",
    "EXPIRED_WARNING_1": "Your demonstration period expired on ",
    "EXPIRED_WARNING_2": " You can keep viewing your maps without editing them.",
    "MESS_GOOGLE_ACCOUNT_1": "Having signed in through Google with the email address ",
    "MESS_GOOGLE_ACCOUNT_2": "Smxstudio is automatically connected to your Google Drive.",
    "MESS_GOOGLE_ACCOUNT_3": "You can edit your profile fields from your Google Account.",
    "TRASH_DELETE_CONFIRM": "If you confirm, the map will be deleted permanently.",
    "TRASH_RESTORE_OPEN_CONFIRM": "Do you want to restore the document and open it?",
    "TRASH_REMOVE_CONFIRM": "If you confirm, the map will be removed from your list and to open it you will need the link from the author.",
    "EXISTING_ACCOUNT": "Existing account",
    "NOTIFICATION_OPEN_TOOLTIP": "Open",
    "SHARED_VIEW_MINE": "Shared map",
    "SHARED_EDIT_MINE": "Shared map",
    "SHARED_VIEW_OTHER_AUTHOR": "Map by",
    "SHARED_EDIT_OTHER_AUTHOR": "Map by",
    "PASSWORD_UPDATED": "Password successfully changed",
    "CONTINUE_WITH_GOOGLE": "Continue with Google",
    "IMPORT_DESCRIPTION": "Choose a .sme file from your local disk and import it into Smxstudio",
    "auth/too-many-requests": "Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.",
    "auth/wrong-password": "Wrong Password",
    "MSG_BLOCKED_POPUP": "Popups are blocked on your browser, click su ok to open map",
    "HOME_ERROR_GENERIC_MAP_UPLOAD": "Error on upload map",
    "MAP_VIEW_VIEW_BUTTON": "View Only",
    "MAP_VIEW_VIEW_BUTTON_MESSAGE": "You can only view this map. Make a copy if you want to edit it",
    "DEEP_SHOW_IMAGE": "Show image",
    "DEEP_HIDE_IMAGE": "Hide image",
    "RICONNNECT_GOOGLE_ACCOUNT": "Warning. Try to reconnect your Google Account!",
    "DELETE_ALL_DATA": "Delete all data",
    "DESC_DELETE_DATA": "Save the User code! If you want to recover the maps go to the dedicated page (admin-move-map) and when the user is logged in, check the new UID and copy the data from the old one to the new.",
    "OTHER_LANGUAGES": "Other languages",
    "MAPEDIT_SETTINGS_TITLE": "Map settings",
    "DOC_TRASHED_WARNING": "The document has been moved to the trash. Do you want to restore and update it?",
    "DOC_ATTACHED_WARNING": "The node already contains an attached document. Do you want to replace it?",
    "ASK_IMPORT_OR_ATTACH": "Want to import a file or add an attachment to the map?",
    "IMPORT_FILE": "Import file",
    "ATTACH_FILE": "Attach",
    "DROP_MULTIPLE_FILES": "You cannot drag more than one item at a time onto the open form.",
    "DROP_HERE": "Drop here",
    "BROWSE": "Browse"
}